export const mockLegalConsentsProps = {
  data: {
    sectionsList: {
      items: [
        {
          id: 'china-optional-consents',
          name: 'china-optional-consents',
          index: 1,
          countries: ['CN'],
          options: ['join-now'],
          sectionType: 'optional',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'china-optional-consents-header',
              name: 'china-optional-consents-header',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              headerContainerClassName: 'm-header-no-test-override-cn',
              headerContainerClassNameOverride: null,
              header: null,
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: "Don't miss account updates, program news and exclusive savings offers.",
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'cnAccountUpdatesAndNews',
              name: 'cnAccountUpdatesAndNews',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email, text messages, push notices, app alerts, social media, direct mail, and other channels.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'cnOoffersAndOtherOffers',
              name: 'cnOoffersAndOtherOffers',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like for the Marriott Group to share my personal data with Select Authorized Licensees, as defined in the <u><a href=\\"/about/privacy/mainland-china/modal.mi\\" target=\\"_blank\\">Mainland China Privacy Statement</a></u>, so I may receive offers and marketing.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'china-required-consents',
          name: 'china-required-consents',
          index: 2,
          countries: ['CN'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'required',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'china-required-consents-header',
              name: 'china-required-consents-header',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['non-member-reservation'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Required Consents',
              headerClassName: null,
              headerClassNameOverride: 'header-class',
              subHeader: 'Please carefully read and consent to Marriott policies.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
            {
              id: 'china-required-consents-header-second',
              name: 'china-required-consents-header-second',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Marriott Policies',
              headerClassName: null,
              headerClassNameOverride: 'header-class',
              subHeader: 'Please carefully read and consent to Marriott policies.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
            {
              id: 'china-required-consents-header-second',
              name: 'china-required-consents-header-second',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['non-member-reservation-instant-join'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: null,
              headerClassName: null,
              headerClassNameOverride: 'header-class',
              subHeader: 'Please carefully read and consent to Marriott policies.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'cnPersonalDataRequired',
              name: 'cnPersonalDataRequired',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'By making a reservation, I agree to the Marriott Group’s <a href=\\"/about/terms-of-use-modal.mi\\" target=\\"_blank\\">Terms of Use</a>, and to the Marriott Group’s processing of my personal data in accordance with the <a href=\\"/about/privacy/mainland-china/modal.mi\\" target=\\"_blank\\">Mainland China Privacy Statement</a>.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'cnCrossBorderPersonalDataRequired',
              name: 'cnCrossBorderPersonalDataRequired',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['join-now'],
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I agree to the cross-border transfer of my personal data to the Marriott Group (including Marriott International) for the purposes set forth in the <a href=\\" /about/privacy/mainland-china/modal.mi\\" target=\\"_blank\\">Mainland China Privacy Statement</a>.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'cnCrossBorderPersonalData',
              name: 'cnCrossBorderPersonalData',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I agree to the cross-border transfer of my personal data to the <a title=\\"marriott group\\" href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_blank\\"><u>Marriott Group</u></a> for the purposes described in Marriott’s <a title=\\"main land\\" href=\\"/about/privacy/mainland-china/modal.mi\\" target=\\"_blank\\"><u>Mainland China Privacy Statement</u>,</a> including my enrollment in Marriott Bonvoy and my receipt of membership services and related benefits. I understand that I may contact the Marriott Group via the <a title=\\"contact\\" href=\\"/about/privacy/mainland-china/contact-us/modal.mi\\" target=\\"_blank\\"><u>contact details</u></a> listed in the Mainland China Privacy Statement. (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'japan-vietnam-optional-consents',
          name: 'japan-vietnam-optional-consents',
          index: 1,
          countries: ['JP', 'VN', 'JP', 'VN'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'optional',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'optinal-header-vietnam',
              name: 'optinal-header-vietnam',
              index: 1,
              forCountries: ['VN'],
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: null,
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: null,
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description:
                'I understand by providing ALL of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'jpPersonalDataRequired-first',
              name: 'jpPersonalDataRequired-first',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['join-now'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email, mobile phone notifications, text messages, and other channels, as described in the Global Privacy Statement.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'jpSharePersonalData-first',
              name: 'jpSharePersonalData-first',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['join-now'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like for the Marriott Group to share my personal data with Authorized Licensees, as defined in the Global Privacy Statement so I may receive offers and marketing via email.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'jpPersonalDataRequired',
              name: 'jpPersonalDataRequired',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email, mobile phone notifications, text messages, and other channels, as described in the Global Privacy Statement.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'jpSharePersonalData',
              name: 'jpSharePersonalData',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like for the Marriott Group to share my personal data with Authorized Licensees so I may receive personalized offers and marketing via email, mobile phone notifications, text messages, and other channels, as described in the Global Privacy Statement\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'japan-required-consents',
          name: 'japan-required-consents',
          index: 2,
          countries: ['JP'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'required',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [],
          checkboxes: [
            {
              id: 'jpCrossBorderPersonalDataRequired-first',
              name: 'jpCrossBorderPersonalDataRequired-first',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: false,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'By registering, I agree to the <a href=\\"/about/terms-of-use-modal.mi\\" target=\\"_parent\\"><u>Marriott Terms and Conditions</u></a> and the Marriott Bonvoy <a href=\\"/loyalty/terms.mi\\" target=\\"_parent\\"><u>Terms and Conditions</u></a>. I also consent to the collection, use, sharing of my personal data with third parties and transfer of my personal data internationally in accordance with Marriott\\\'s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_parent\\"><u>Global Privacy Statement</u></a>. I am aware that my personal data may be transferred to the location where <a href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_parent\\"><u>Marriott Group</u></a> entities are located, and that further information on data protection in each region can be found at <a href=\\"https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku\\" target=\\"_blank\\"><u>Personal Information Protection Commission (PPC)</u></a> I understand that you can refer to the website of the website.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'jpCrossBorderPersonalDataRequired',
              name: 'jpCrossBorderPersonalDataRequired',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['non-member-reservation-instant-join'],
              excludeOptions: ['reservation'],
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: false,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'By signing up, I agree to Marriott’s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and <a href="/loyalty/terms.mi" target="_blank">Marriott Bonvoy Terms and Conditions</a>. I also agree to my personal data being collected, used, shared with third parties, and transferred globally in accordance with Marriott’s <a href="/marriott/privacy-modal.mi" target="_blank">Global Privacy Statement</a>. I understand that my personal data may be transferred to locations in which <a href="/about/privacy/marriott-group/modal.mi" target="_blank">Marriott Group</a> entities are located, and that I may refer to the <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku" target="_blank" class="external-site">PPC’s website<span aria-hidden="true" class="t-icon-external-site"></span></a> for more information about data protection in various locations.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'south-korea-optional-consents-join-now',
          name: 'south-korea-optional-consents-join-now',
          index: 4,
          countries: ['KR', 'KR'],
          options: ['join-now'],
          sectionType: 'optional',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'south-korea-optional-consents-join-now-headers',
              name: 'south-korea-optional-consents-join-now-headers',
              index: 4,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: null,
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: null,
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description:
                'I understand by providing ALL of the three consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'skrCollectPersonalDataConsentOptional',
              name: 'skrCollectPersonalDataConsentOptional',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to collection and use of Personal Data for personalized services (Optional)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/personalDataUseMarketing.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'skrPersonalDataProvisionConsentOptional',
              name: 'skrPersonalDataProvisionConsentOptional',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'Consent to provision of Personal Data to third parties for personalized services (Optional)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/provisionDataUseMarketing.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'skrCrossBorderPersonalDataOptional',
              name: 'skrCrossBorderPersonalDataOptional',
              index: 3,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to cross-border transfer of Personal Data for personalized services (Optional)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/consentCrossBorderuseMarketing.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'south-korea-optional-consents',
          name: 'south-korea-optional-consents',
          index: 3,
          countries: ['KR'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'optional',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'south-korea-optional-consent-headers',
              name: 'south-korea-optional-consent-headers',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: null,
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description:
                'I understand by providing ALL of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'collectPersonalDataConsentOptional',
              name: 'collectPersonalDataConsentOptional',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to collection and use of Personal Data for marketing purposes (Optional)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/personalDataUseMarketing.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'personalDataProvisionConsentOptional',
              name: 'personalDataProvisionConsentOptional',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'Consent to provision of Personal Data to third parties for marketing purposes (Optional)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/provisionDataUseMarketing.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'crossBorderPersonalDataOptional',
              name: 'crossBorderPersonalDataOptional',
              index: 3,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to cross-border transfer of Personal Data for marketing purposes (Optional)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/consentCrossBorderuseMarketing.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'electronicMarketingConsentOptional',
              name: 'electronicMarketingConsentOptional',
              index: 4,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: "'Consent to electronic receipt of marketing information (Optional)\n\n ",
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/consentMarketingChannel.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'south-korea-privacy-consents-data',
          name: 'south-korea-privacy-consents-data',
          index: 1,
          countries: ['KR', 'KR'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'agreeAll',
          showTopDivider: true,
          showBottomDivider: true,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'south-korea-privacy-consents-consents-headers',
              name: 'south-korea-privacy-consents-consents-headers',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['join-now'],
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Privacy Consents',
              headerClassName: null,
              headerClassNameOverride: 'm-header-override',
              subHeader: null,
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
            {
              id: 'south-korea-privacy-consents-consents-join-now-headers',
              name: 'south-korea-privacy-consents-consents-join-now-headers',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              headerContainerClassName: 'm-garker-background',
              headerContainerClassNameOverride: null,
              header: 'Privacy Consents',
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: null,
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'agreeAllConsent',
              name: 'agreeAllConsent',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'By signing up, I agree to Marriott\\\'s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_blank">Terms and Conditions</a> and <u>confirm that I am 16 years or older</u>.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'south-korea-required-consents-data',
          name: 'south-korea-required-consents-data',
          index: 2,
          countries: ['KR', 'KR'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'required',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: 'Please check all required consents!',
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'south-korea-required-consents-consents-headers',
              name: 'south-korea-required-consents-consents-headers',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['join-now'],
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Required Consents',
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: null,
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description:
                'I understand that the following required consents are necessary to successfully make this reservation.',
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
            {
              id: 'south-korea-required-consents-headers-join-now',
              name: 'south-korea-required-consents-headers-join-now',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: null,
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader: 'Required Consents',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description:
                'I understand that the following required consents are necessary to successfully make this reservation.',
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'collectPersonalDataConsentRequired',
              name: 'collectPersonalDataConsentRequired',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to the provision of Personal Data to third parties (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consents!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: '_self',
            },
            {
              id: 'personalDataProvisionConsentRequiredData',
              name: 'personalDataProvisionConsentRequiredData',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['join-now'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to provision and cross-border provision of Personal Data (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: '/about/privacy/data-collection-use-disclosure.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select mandatory consents!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: '_self',
            },
            {
              id: 'personalDataProvisionConsentRequiredContent',
              name: 'personalDataProvisionConsentRequiredContent',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown: 'Consent to provision and cross-border transfer of Personal Data (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: 'https://www.marriott.com/about/ccpa/modal.mi',
              termsLinkLabel: 'Terms',
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'non-apec-countries-optional-consents',
          name: 'non-apec-countries-optional-consents',
          index: 1,
          countries: [
            'CY',
            'CX',
            'ZW',
            'SX',
            'GM',
            'CO',
            'TN',
            'LT',
            'ET',
            'ST',
            'GD',
            'BV',
            'UG',
            'AQ',
            'GU',
            'NG',
            'NU',
            'TW',
            'SA',
            'WS',
            'MV',
            'ES',
            'CZ',
            'TL',
            'VI',
            'BF',
            'JM',
            'NL',
            'IS',
            'PH',
            'TZ',
            'AO',
            'RE',
            'FI',
            'MZ',
            'GT',
            'SK',
            'TO',
            'SY',
            'GY',
            'MX',
            'TM',
            'GF',
            'DZ',
            'MT',
            'LC',
            'JO',
            'EH',
            'GE',
            'TF',
            'ME',
            'MA',
            'AL',
            'WF',
            'EG',
            'RW',
            'IO',
            'GA',
            'XK',
            'TC',
            'SG',
            'SI',
            'GB',
            'BB',
            'VU',
            'ZA',
            'IT',
            'LV',
            'PG',
            'MG',
            'AU',
            'CA',
            'BJ',
            'KY',
            'GP',
            'IQ',
            'BT',
            'VG',
            'MR',
            'HT',
            'AZ',
            'RO',
            'MN',
            'LS',
            'GE',
            'NZ',
            'CL',
            'KW',
            'BD',
            'AM',
            'MG',
            'SC',
            'BA',
            'US',
            'IN',
            'BR',
            'TR',
            'MX',
            'CH',
            'RU',
            'IT',
            'AE',
            'SA',
            'FR',
            'AU',
            'DE',
            'ZA',
            'NG',
            'PK',
            'ID',
            'GB',
            'AR',
            'LB',
            'MK',
            'NO',
            'PY',
            'PH',
            'TZ',
            'CI',
            'UY',
            'EC',
            'PE',
            'KH',
            'LA',
            'LK',
            'MV',
            'MZ',
            'OM',
            'GN',
            'VE',
            'KZ',
            'AO',
            'NC',
            'KG',
            'TG',
            'YE',
            'ET',
            'GA',
            'DZ',
            'TM',
            'TN',
            'NP',
            'TD',
            'MM',
            'UG',
            'CO',
            'GT',
            'HN',
            'PK',
            'GH',
            'SN',
            'JO',
            'MA',
            'SY',
            'ML',
            'SD',
            'IS',
            'FI',
            'EE',
            'LV',
            'LT',
            'SK',
            'SI',
            'HR',
            'BA',
            'ME',
            'AL',
            'RS',
            'XK',
            'MK',
            'MT',
            'CY',
            'BY',
            'UA',
            'MD',
            'GE',
            'AM',
            'AZ',
            'KZ',
            'UZ',
            'TM',
            'KG',
            'TJ',
            'AF',
            'PK',
            'IN',
            'NP',
            'LK',
            'BD',
            'BT',
            'MV',
            'TW',
            'KP',
            'MN',
            'TH',
            'KH',
            'LA',
            'MM',
            'MY',
            'SG',
            'BN',
            'ID',
            'PH',
            'TL',
            'AU',
            'NZ',
            'PG',
            'FJ',
            'SB',
            'VU',
            'WS',
            'TO',
            'KI',
            'TV',
            'NR',
            'PW',
            'FM',
            'MH',
            'US',
            'CA',
            'MX',
            'GT',
            'SV',
            'HN',
            'NI',
            'CR',
            'PA',
            'CU',
            'DO',
            'HT',
            'JM',
            'TT',
            'BB',
            'LC',
            'GD',
            'VC',
            'KN',
            'AG',
            'BS',
            'DM',
            'PM',
            'BZ',
            'GY',
            'SR',
            'VE',
            'CO',
            'EC',
            'PE',
            'BR',
            'BO',
            'PY',
            'UY',
            'CL',
            'AR',
            'GL',
            'IS',
            'AR',
            'QA',
          ],
          options: ['join-now', 'non-member-reservation-instant-join'],
          sectionType: 'optional',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'non-apec-required-consents-header-data',
              name: 'non-apec-required-consents-header-data',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Marriott Policies',
              headerClassName: null,
              headerClassNameOverride: 'header-class',
              subHeader: null,
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
            {
              id: 'non-apec-required-consents-header-content',
              name: 'non-apec-required-consents-header-content',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['non-member-reservation-instant-join'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Marriott Policies',
              headerClassName: null,
              headerClassNameOverride: 'header-class',
              subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'subscriptionsOffers',
              name: 'subscriptionsOffers',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'subscriptions3rdParty',
              name: 'subscriptions3rdParty',
              index: 2,
              forCountries: null,
              excludeCountries: ['US'],
              forOptions: null,
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I would like for the Marriott Group to share my personal data with Authorized Licensees, as defined in the Global Privacy Statement so I may receive offers and marketing via email.\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'non-apec-countries-required-consents',
          name: 'non-apec-countries-required-consents',
          index: 2,
          countries: [
            'CY',
            'CX',
            'ZW',
            'SX',
            'GM',
            'CO',
            'TN',
            'LT',
            'ET',
            'ST',
            'GD',
            'BV',
            'UG',
            'AQ',
            'GU',
            'NG',
            'NU',
            'TW',
            'SA',
            'WS',
            'MV',
            'ES',
            'CZ',
            'TL',
            'VI',
            'BF',
            'JM',
            'NL',
            'IS',
            'PH',
            'TZ',
            'AO',
            'RE',
            'FI',
            'MZ',
            'GT',
            'SK',
            'TO',
            'SY',
            'GY',
            'MX',
            'TM',
            'GF',
            'DZ',
            'MT',
            'LC',
            'JO',
            'EH',
            'GE',
            'TF',
            'ME',
            'MA',
            'AL',
            'WF',
            'EG',
            'RW',
            'IO',
            'GA',
            'XK',
            'TC',
            'SG',
            'SI',
            'GB',
            'BB',
            'VU',
            'ZA',
            'IT',
            'LV',
            'PG',
            'MG',
            'AU',
            'CA',
            'BJ',
            'KY',
            'GP',
            'IQ',
            'BT',
            'VG',
            'MR',
            'HT',
            'AZ',
            'RO',
            'MN',
            'LS',
            'GE',
            'NZ',
            'CL',
            'KW',
            'BD',
            'AM',
            'MG',
            'SC',
            'BA',
            'US',
            'IN',
            'BR',
            'TR',
            'MX',
            'CH',
            'RU',
            'IT',
            'AE',
            'SA',
            'FR',
            'AU',
            'DE',
            'ZA',
            'NG',
            'PK',
            'ID',
            'GB',
            'AR',
            'LB',
            'MK',
            'NO',
            'PY',
            'PH',
            'TZ',
            'CI',
            'UY',
            'EC',
            'PE',
            'KH',
            'LA',
            'LK',
            'MV',
            'MZ',
            'OM',
            'GN',
            'VE',
            'KZ',
            'AO',
            'NC',
            'KG',
            'TG',
            'YE',
            'ET',
            'GA',
            'DZ',
            'TM',
            'TN',
            'NP',
            'TD',
            'MM',
            'UG',
            'CO',
            'GT',
            'HN',
            'PK',
            'GH',
            'SN',
            'JO',
            'MA',
            'SY',
            'ML',
            'SD',
            'IS',
            'FI',
            'EE',
            'LV',
            'LT',
            'SK',
            'SI',
            'HR',
            'BA',
            'ME',
            'AL',
            'RS',
            'XK',
            'MK',
            'MT',
            'CY',
            'BY',
            'UA',
            'MD',
            'GE',
            'AM',
            'AZ',
            'KZ',
            'UZ',
            'TM',
            'KG',
            'TJ',
            'AF',
            'PK',
            'IN',
            'NP',
            'LK',
            'BD',
            'MV',
            'TW',
            'KP',
            'MN',
            'TH',
            'KH',
            'LA',
            'MM',
            'MY',
            'SG',
            'BN',
            'ID',
            'PH',
            'TL',
            'AU',
            'NZ',
            'PG',
            'FJ',
            'SB',
            'VU',
            'WS',
            'TO',
            'KI',
            'TV',
            'NR',
            'PW',
            'FM',
            'MH',
            'US',
            'CA',
            'MX',
            'GT',
            'SV',
            'HN',
            'NI',
            'CR',
            'PA',
            'CU',
            'DO',
            'HT',
            'JM',
            'TT',
            'BB',
            'LC',
            'GD',
            'VC',
            'KN',
            'AG',
            'BS',
            'DM',
            'PM',
            'BZ',
            'GY',
            'SR',
            'VE',
            'CO',
            'EC',
            'PE',
            'BR',
            'BO',
            'PY',
            'UY',
            'CL',
            'AR',
            'GL',
            'IS',
            'AR',
            'QA',
          ],
          options: ['join-now', 'non-member-reservation'],
          sectionType: 'required',
          showTopDivider: false,
          showBottomDivider: false,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'non-apec-required-consents-header-content-second',
              name: 'non-apec-required-consents-header-content-second',
              index: 1,
              forCountries: ['join-now'],
              excludeCountries: null,
              forOptions: ['non-member-reservation'],
              excludeOptions: null,
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Marriott Policies',
              headerClassName: null,
              headerClassNameOverride: 'header-class',
              subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description:
                'I understand by providing ALL of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'non-apec-countries-accountTermsAndConditionsData',
              name: 'non-apec-countries-accountTermsAndConditionsData',
              index: 3,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['join-now'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: false,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  '<p>By signing up, I agree to Marriott\\\'s <a href="/about/terms-of-use-modal.mi" target="_blank"><u>Terms of Use</u></a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_blank"><u>Terms and Conditions</u></a> and <u>confirm that I am 16 years or older</u>.</p>\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'non-apec-countries-accountTermsAndConditionsContent',
              name: 'non-apec-countries-accountTermsAndConditionsContent',
              index: 3,
              forCountries: null,
              excludeCountries: null,
              forOptions: ['non-member-reservation'],
              excludeOptions: null,
              isDisabled: false,
              defaultChecked: true,
              showCheckbox: false,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'By signing up, I agree to Marriott\\\'s&nbsp;<a href="/about/terms-of-use-modal.mi">Terms of Use</a>,&nbsp;<u><a href="/marriott/privacy-modal.mi" target="_self">Privacy Statement</a>,</u> <u><a href="/marriott-rewards/data-protection.mi" target="_blank">Data Protection Clause</a></u> and acknowledge the <a href="/about/ccpa/modal.mi" target="_blank">California Notice of Financial Incentive</a>.</p>\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: null,
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
        {
          id: 'vietnam-required-consents',
          name: 'vietnam-required-consents',
          index: 1,
          countries: ['VN', 'VN'],
          options: ['join-now', 'non-member-reservation-instant-join', 'non-member-reservation'],
          sectionType: 'required',
          showTopDivider: true,
          showBottomDivider: true,
          containerClassName: null,
          containerClassNameOverride: null,
          errorMessage: null,
          errorMessageClassName: null,
          errorMessageClassNameOverride: null,
          headers: [
            {
              id: 'required-consents-header-contents',
              name: 'required-consents-header-contents',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['non-member-reservation'],
              headerContainerClassName: null,
              headerContainerClassNameOverride: null,
              header: 'Required Consents',
              headerClassName: null,
              headerClassNameOverride: null,
              subHeader:
                'By ticking the boxes below, I acknowledge and understand that the following required consents are necessary to make a reservation.',
              subHeaderClassName: null,
              subHeaderClassNameOverride: null,
              description: null,
              descriptionClassName: null,
              descriptionClassNameOverride: null,
            },
          ],
          checkboxes: [
            {
              id: 'vnPersonalDataRequiredData',
              name: 'vnPersonalDataRequiredData',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['non-member-reservation'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I have read and agreed to Marriott’s <a href="/about/terms-of-use-modal.mi" target="_blank">Terms of Use</a> and my personal data being collected, used, shared and transferred in accordance with Marriott’s <a href="/marriott/privacy-modal.mi" target="_blank">Global Privacy Statement</a>. (Required)\',\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'vnCrossBorderPersonalDataRequiredData',
              name: 'vnCrossBorderPersonalDataRequiredData',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['non-member-reservation'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I agree to the cross-border transfer of my personal data to the <a href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_parent\\">Marriott Group</a> for the purposes described in Marriott’s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_parent\\" title=\\"privacy\\">Global Privacy Statement</a>, including my enrollment in Marriott Bonvoy and my receipt of membership services and related benefits. (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'vnRequiredPersonalData',
              name: 'vnRequiredPersonalData',
              index: 1,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['non-member-reservation'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I have read and agreed to Marriott’s <a href=\\"/about/terms-of-use-modal.mi\\" target=\\"_blank\\">Terms of Use</a> and my personal data being collected, used, shared and transferred in accordance with Marriott’s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_blank\\">Global Privacy Statement</a>. (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
            {
              id: 'vnCrossBorderRequiredPersonalData',
              name: 'vnCrossBorderRequiredPersonalData',
              index: 2,
              forCountries: null,
              excludeCountries: null,
              forOptions: null,
              excludeOptions: ['non-member-reservation'],
              isDisabled: false,
              defaultChecked: false,
              showCheckbox: true,
              checkboxLabelContainerClassName: null,
              checkboxLabelContainerClassNameOverride: null,
              checkboxContainerClassName: null,
              checkboxContainerClassNameOverride: null,
              checkboxClassName: null,
              checkboxClassNameOverride: null,
              label: {
                markdown:
                  'I agree to the cross-border transfer of my personal data to the <a href=\\"/about/privacy/marriott-group/modal.mi\\" target=\\"_blank\\">Marriott Group</a> for the purposes described in Marriott’s <a href=\\"/marriott/privacy-modal.mi\\" target=\\"_blank\\">Global Privacy Statement</a>, including the completion of my reservation and the provision of hotel accommodation and related services. (Required)\n\n ',
              },
              labelClassName: null,
              labelClassNameOverride: null,
              termsLink: null,
              termsLinkLabel: null,
              termsLinkLabelClassName: null,
              termsLinkLabelClassNameOverride: null,
              errorMessage: 'Please select required consent!',
              errorMessageClassName: null,
              errorMessageClassNameOverride: null,
              termsLinkTarget: null,
            },
          ],
        },
      ],
    },
  },
};

export const CountriesAndCountryCode = [
  { label: 'USA', value: 'US' },
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Anguilla', value: 'AI' },
  { label: 'Antarctica', value: 'AQ' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bermuda', value: 'BM' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bonaire, Saint Eustatius and Saba', value: 'BQ' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Bouvet Island', value: 'BV' },
  { label: 'Br Indian Ocean Terr', value: 'IO' },
  { label: 'Brazil', value: 'BR' },
  { label: 'Brunei Darussalam', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Cape Verde', value: 'CV' },
  { label: 'Cayman Islands', value: 'KY' },
  { label: 'Cent Africa Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cocos Islands', value: 'CC' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoro Islands', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Congo, Dem. Republic', value: 'CD' },
  { label: 'Cook Islands', value: 'CK' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Curacao', value: 'CW' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Faeroe Islands', value: 'FO' },
  { label: 'Falkland Islands', value: 'FK' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'French Guiana', value: 'GF' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'French Southern Terr', value: 'TF' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Gaza', value: 'XA' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Gibraltar', value: 'GI' },
  { label: 'Greece', value: 'GR' },
  { label: 'Greenland', value: 'GL' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Heard & Mcdonald Isl', value: 'HM' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indian Ocean Islands', value: 'XI' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Ivory Coast', value: 'CI' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Korea, Dem. Peoples', value: 'KP' },
  { label: 'Kosovo', value: 'XK' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Lao P D R', value: 'LP' },
  { label: 'Laos', value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Leeward Islands', value: 'LW' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Macau', value: 'MO' },
  { label: 'Macedonia', value: 'MK' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Montserrat', value: 'MS' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Niue', value: 'NU' },
  { label: 'Norfolk Island', value: 'NF' },
  { label: 'Northern Mariana Isl', value: 'MP' },
  { label: 'Norway', value: 'NO' },
  { label: 'Oman', value: 'OM' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palestine', value: 'PS' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pitcairn Islands', value: 'PN' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Reunion', value: 'RE' },
  { label: 'Romania', value: 'RO' },
  { label: 'Russia', value: 'RU' },
  { label: 'Rwanda', value: 'RW' },
  { label: 'Saint Barthelemy', value: 'BL' },
  { label: 'Saint Helena', value: 'SH' },
  { label: 'Saint Kitts & Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Martin', value: 'MF' },
  { label: 'Saint Pierre & Miquelon', value: 'PM' },
  { label: 'Saint Vincent', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Sint Maarten', value: 'SX' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Georgia', value: 'GS' },
  { label: 'South Korea', value: 'KR' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Svalbard', value: 'SJ' },
  { label: 'Swaziland', value: 'SZ' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Syria', value: 'SY' },
  { label: 'Taiwan', value: 'TW' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Timor Leste', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad & Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Turks and Caicos', value: 'TC' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Vatican City', value: 'VA' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnam', value: 'VN' },
  { label: 'Virgin Islands, UK', value: 'VG' },
  { label: 'Virgin Islands, US', value: 'VI' },
  { label: 'Western Sahara', value: 'EH' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' },
];
